import { useMemo } from "react";
import type { PropsWithChildren } from "react";
import { ThemeProvider, createTheme, CssBaseline } from "@mui/material";
import { useOfficeTheme } from "@/office/theme";

/**
 * Wraps the app in an MUI ThemeProvider whose palette mode (light/dark) tracks
 * the Outlook theme (via useOfficeTheme). Reactively rebuilds the theme when
 * the user switches Outlook's appearance.
 */
export function OfficeThemeProvider({ children }: PropsWithChildren) {
  const mode = useOfficeTheme();
  const theme = useMemo(
    () =>
      createTheme({
        palette: { mode },
        shape: { borderRadius: 8 },
      }),
    [mode],
  );
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
}
